import { ReactNode, useEffect, useRef, useState } from 'react';
import cls from './Popover.module.scss';
import dropdownIcon from 'assets/images/icon/dropdown-icon.svg';

interface Props {
    trigger: ReactNode;
    children: ReactNode;
}

export const Popover = ({ trigger, children }: Props) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const toggle = () => setOpen(prev => !prev);
    const close = () => setOpen(false);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (!ref.current) return;
            if (!ref.current.contains(e.target as Node)) {
                close();
            }
        };

        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);

    return (
        <div className={`${cls.wrapper} ${open ? cls.active : ''}`} ref={ref}>
            <div className={cls.trigger} onClick={toggle}>
                {trigger}
                <img className={`${cls.arrow} ${open ? cls.open : ''}`} src={dropdownIcon} alt="Dropdown" />
            </div>

            {open && (
                <div className={cls.tooltip}>
                    {children}
                </div>
            )}
        </div>
    );
};